import { Slider } from "@mantine/core";

import classes from "./index.module.css";
import { trackCustomEvent } from "utils/metaPixel";

interface ICalculatorSlider {
  color?: string;
  disabled?: boolean;
  max: number;
  min: number;
  step: number;
}

const CalculatorSlider = ({
  color = "#2C5218",
  disabled,
  max,
  min,
  step,
  ...props
}: ICalculatorSlider) => {
  function handleSliderChange() {
    const isCalculatorUsed = localStorage.getItem("calculatorSliderUsed");

    if (!isCalculatorUsed) {
      trackCustomEvent("CalculatorUsed");
      localStorage.setItem("calculatorSliderUsed", "true");
    }
  }

  return (
    <Slider
      classNames={{
        thumb: classes.thumb,
        bar: classes.bar,
        track: classes.track,
      }}
      color={color}
      thumbLabel="Slider thumb"
      min={min}
      max={max}
      step={step}
      mt={10}
      disabled={disabled}
      onChangeEnd={handleSliderChange}
      {...props}
    />
  );
};

export default CalculatorSlider;
